<template>
    <keep-alive>
        <el-menu
            class="side-bar-menu"
            :collapse="collapse"
            ref="elMenu"
            background-color="#1e1e28"
            text-color="#fff"
            active-text-color="#fff"
            :default-openeds="openeds"
            :unique-opened="uniqueOpened"
            :router="true">
            <menu-item
                v-for="(menu, index) in menus"
                :menu="menu"
                :key="index + menu.resourceCode">
            </menu-item>
        </el-menu>
    </keep-alive>
</template>

<script>
import { defineComponent, watch, ref } from 'vue';
import { useRoute } from 'vue-router';
import MenuItem from './MenuItem';

export default defineComponent({
    name: 'SidebarMenu',
    components: {
        MenuItem
    },
    props: {
        menus: {
            type: Array,
            default () {
                return [];
            }
        },
        collapse: {
            type: Boolean,
            default () {
                return true;
            }
        },
        uniqueOpened: {
            type: Boolean,
            default () {
                return true;
            }
        },
        openeds: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    setup(props) {
        // console.log("sidebarmenus setup..", props);
        const elMenu = ref(null);
        const route = useRoute();

        // methods
        const traversalParent = (item) => {
            if (!item.$refs['submenu-title']) return false;
            item.$refs['submenu-title'].classList.add('defaultBg');
            if (item.parentMenu) {
                traversalParent(item.parentMenu);
            }
        };

        // watch
        watch(route, (newVal, oldVal) => {
            // console.log("route newVal:", newVal, "route oldVal:", oldVal);
            const { submenus, items } = elMenu;
            for (const key in submenus) {
                // 先遍历所有有子菜单的项，去掉defaultBg
                if (!submenus[key].items[newVal.path]) {
                    submenus[key].$refs['submenu-title'].classList.remove('defaultBg');
                }
            }
            if (items && items[newVal.path]) {
                traversalParent(items[newVal.path].parentMenu); // 递归父菜单设置高亮
            }
        });
    }
});
</script>
